export default "__VITE_ASSET__cbd97e3e__"